import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { userActions } from "../store/userSlice";
import { useHistory } from "react-router-dom";

import {
  Button,
  Heading,
  Box,
  Input,
  useToast,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";

import db, { auth } from "../firebase";

function LogIn() {
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        history.replace("/browse");
      }
    });
  }, []);

  const signInForm = (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (email.trim().length == 0 || password.trim().length == 0) {
      toast({
        title: "Missing fields.",
        description: "Please fill the empty fields.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setIsLoading(false);
    } else {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((userCredentials) => {
          db.collection("users")
            .doc(userCredentials.user.uid)
            .get()
            .then((doc) => {
              let data = doc.data();
              dispatch(
                userActions.userLogin({
                  name: data.name,
                  email: data.email,
                  userId: userCredentials.user.uid,
                })
              );
            });

          toast({
            title: "Signed in.",
            description: "You just signed in.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          history.replace("/browse");
        })
        .catch((error) => {
          toast({
            title: "Wrong",
            description: "Incorrect email or password.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
        });
    }
  };

  return (
    <MainDiv>
      <Heading as="h1" size="lg">
        Sign In
      </Heading>
      <Box
        maxW="sm"
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={9}
      >
        <form onSubmit={signInForm}>
          <FormControl width="240px" id="email" marginBottom={5}>
            <FormLabel>Your email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value.trim())}
            />
          </FormControl>
          <FormControl width="240px" id="password" marginBottom={5}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value.trim())}
            />
          </FormControl>
          <Button
            type="submit"
            color="white"
            bgColor="#EE575D"
            _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
            isLoading={isLoading}
            loadingText="SignIn..."
          >
            Sign In
          </Button>
        </form>
      </Box>
    </MainDiv>
  );
}

export default LogIn;
const MainDiv = styled.div`
  height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    margin-top: 50px;
    margin-bottom: 20px;
  }
  form {
    FormControl {
      margin-bottom: 20px;
    }
    button {
      margin-top: 5px;
    }
  }
`;
